
(function () {
  var box = document.querySelector('.meta-variants');
  if (!box) return;

  var max = parseInt(box.getAttribute('data-flavour-max'), 10) || 4;
  var countEl = box.querySelector('[data-flavour-count]');
  var maxEl = box.querySelector('[data-flavour-max]');
  if (maxEl) maxEl.textContent = String(max);

  // get Add to Cart button
  var atcBtn = document.querySelector('[data-add-to-cart]');

  function rowValue(row) {
    var input = row.querySelector('.qty-input');
    var v = parseInt(input.value, 10);
    return isNaN(v) ? 0 : v;
  }
  function setRowValue(row, next) {
    var input = row.querySelector('.qty-input');
    input.value = String(Math.max(0, next));
  }
  function total() {
    var sum = 0;
    box.querySelectorAll('[data-flavour-row]').forEach(function (row) {
      sum += rowValue(row);
    });
    return sum;
  }

  function updateUI() {
    var t = total();
    if (countEl) countEl.textContent = String(t);

    // toggle "max reached" state
    box.classList.toggle('reached-max', t >= max);

    // enable/disable plus buttons when at cap
    box.querySelectorAll('[data-flavour-row]').forEach(function (row) {
      var plus = row.querySelector('[data-plus]');
      if (!plus) return;
      plus.disabled = (t >= max);
    });

    // ✅ Enable Add to Cart ONLY if total === max
    if (atcBtn) {
      atcBtn.disabled = (t !== max);
    }
  }

  // Attach events
  box.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-minus]');
    var plusBtn  = e.target.closest('[data-plus]');
    if (!minusBtn && !plusBtn) return;

    var row = e.target.closest('[data-flavour-row]');
    if (!row) return;

    var v = rowValue(row);
    var t = total();

    if (minusBtn) {
      if (v > 0) setRowValue(row, v - 1);
    } else if (plusBtn) {
      if (t < max) setRowValue(row, v + 1);
    }
    updateUI();
  });

  // Guard submit if not exactly max
  var form = box.closest('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (total() !== max) {
        e.preventDefault();
        updateUI();
        try {
          alert('Bitte wähle genau ' + max + ' Flavors.');
        } catch(_) {}
      }
    });
  }

  // Initial paint
  updateUI();
})();